
//import { Margin, MarginSharp } from '@mui/icons-material';
import React from 'react'
import { CustomTooltip } from '../customtooltip/CustomTooltip';


export const ButtonAIProvider = ({provider, model}) => {

  const styles = {
    container: {
      alignItems: 'center', // Center vertically
    },
  
    spacer: {
      marginLeft:'5px'
    },

    button: {
      color:'maroon',
      fontSize: '12px',
    
      backgroundColor: 'transparent',
    
      alignItems: 'center', // Center the icon vertically
      padding: '4px', // Optional padding around the button
   
    },
    icon: {
    
      margin: '5px',  
      color:'maroon',
    },
  };

  return (
    
    <CustomTooltip title={model}>
    <span>
      <span style={styles.spacer}></span>
      <span style={styles.button}>
        {provider}: {model}
      </span>
    </span>
     </CustomTooltip>
    
  )
}





